import request from '../utils/request';

function genConfigRecommendationJob() {
  return request({
    method: 'post',
    url: `/jobs/configRecommendation`,
  });
}

function getConfigRecommendationJob(jobId: string) {
  return request({
    method: 'get',
    url: `/jobs/configRecommendation/${jobId}`,
  });
}

function getConfigRecommendationRules() {
  return request({
    method: 'get',
    url: `/configRecommendation/rules`,
  });
}

function getConfigRecommendations() {
  return request({
    method: 'get',
    url: `/configRecommendations`,
  });
}

export default {
  genConfigRecommendationJob,
  getConfigRecommendationJob,
  getConfigRecommendationRules,
  getConfigRecommendations,
};
